/**
 * Project : workspace
 * File    : MathEngine.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package engine.math

import kotlin.math.pow
import kotlin.math.round

/**
 * Represents the math engine class.
 */

class MathEngine {
    fun roundTo(d: Double, decimals: Int): Double {
        val factor = 10.0.pow(decimals)
        return round(d * factor) / factor
    }
//    fun roundTo(d:Double, i: Int): Double{
//        val temp = d.toString().split(".")
//        if(temp.count() >= 2){
//            val prefix = temp[0]
//            if(temp[1].count() >= 2){
//                val suffix = temp[1].substring(0,3)
//                val finalString = "${prefix}.${suffix}"
//                val final = finalString.toDouble()
//                return final
//            }
//        }
//        return d
//    }
}